import * as TK from 'pages/SignInPage/translations/constants';
import { Translations } from 'translations/types';

export const signInPageEnUsLocale: Translations = {
  [TK.SIGN_IN_PAGE_SIGN_UP_SUGGESTION]: 'Don’t have an account?',
  [TK.SIGN_IN_PAGE_SIGN_UP_LINK]: 'Sign Up',
};
